<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12" sm="6" >
        <v-card class="elevation-0 transparent">
          <v-list class="transparent contact">
            <ContactUser v-for="user in users" :key="user.name" :name="user.name" :phone="user.phone" :email="user.email"/>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card class="elevation-0 transparent footer-map">
          <div class="above-box white--text">
            Suite 4/64 Sutton Street North Melbourne, North Melbourne, VIC 3051             
          </div>  
          <div id="constactusmap">
          </div>        
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactUser from 'components/ContactUser.vue';
import Mapbox from 'mapbox-gl'
export default {
  components: {
    ContactUser,
  },
  mounted(){
    this.$nextTick(function () {
      Mapbox.accessToken = this.token
      let map = new Mapbox.Map({
        container: 'constactusmap',
        style: 'mapbox://styles/mapbox/streets-v9',
        pitch: 45,
        center: [144.9382133,-37.7917959],
        zoom: 15,
        interactive: false
      });
      this.landing4 = map;
      map.on('load', ()=> {
        let el = document.createElement('div');
        el.className = 'marker';
        new Mapbox.Marker(el)
          .setLngLat([144.9382133,-37.7909])
          .setPopup(new Mapbox.Popup({offset: 25}) // add popups
              .setHTML('<h3>Suite 4/64 Sutton Street</h3><p>North Melbourne, 3051, VIC</p>'))
          .addTo(map);
      })
    })
  },  
  data() {
    return {
      token: 'pk.eyJ1IjoiYWdhdXNzZW4iLCJhIjoiY2oydXp1dmg0MDAxeDJ2azJjOTM1Y202MCJ9.snYgaaG8eVpXPGw120O5Pg',
      users: [
        {
          name: 'Lachlan Beveridge',
          phone: '0417 792 601',
          email: 'lbeveridge@thinkspatial.com.au'
        },
        {
          name: 'Andrew Gaussen',
          phone: '0408 362 395',
          email: 'agaussen@thinkspatial.com.au'
        },
        {
          name: 'Lynden McGregor',
          phone: '0409 799 862',
          email: 'lmcgregor@thinkspatial.com.au'
        }                
      ]
    }
  }
}
</script>

<style>
  .contact{
    text-align: left;
  }

  .contact-footer {    
    text-shadow: #333 0 1px;
    box-shadow: 0px -1px 16px rgba(0, 0, 0, 625);
    background-image:linear-gradient(#888586, #3a1d0f);
    margin-bottom: 66px;
  }

  .footer-map {
    width: 100%;
    height: 210px;
  }

  #constactusmap{
    height: 100%;
    width: 100%;
    border: 1px solid #808080;
    border-bottom: 1px solid #b3b3b3;
    border-top: 1px solid #555;
  }

  .above-box {
    /* z-index: 1000 !important; */
    background-color: #f1592a;
    padding: 10px;
  }

  .marker {
      background-image: url('../assets/img/icons/map-pin.png');
      background-size: cover;
      width: 50px;
      height: 100px;
      cursor: pointer;
  }
  .mapboxgl-popup {
      max-width: 200px;
  }
  .mapboxgl-popup-content {
      text-align: center;
      font-family: 'Open Sans', sans-serif;
  }  
</style>